export default __webpack_public_path__ + "static/media/company_logo-removebg.c0ecc5e1.png";